.pagination {
    align-self: center;
}
